<script lang="ts">
  import type { CommentAttachment } from '#components/comments/CommentTypes'

  import css from '#css/comments.pcss.json'

  export let attachment: CommentAttachment
  export let onlyAttachment: boolean = false

  const additionalProps = {}
  const classes = [css['comment__attachment__video']]
  let showPlay = true
  let videoId: string
  let params: URLSearchParams

  const knownProviders = [
    'youtube',
    'vimeo'
  ]

  if (onlyAttachment) {
    if (attachment.provider === 'youtube') {
      const url = new URL(attachment.url)
      params = new URLSearchParams();
      const timecode = url.searchParams.get('t');
      if (url.searchParams.has('v')) {
        videoId = url.searchParams.get('v')
      } else {
        const parts = url.pathname.split('/')
        if (parts[1] === 'embed') {
          videoId = parts[2]
        } else {
          videoId = parts[1]
        }
      }
      if (timecode) {
        params.set('start', timecode)
      }
      params.set('enablejsapi', '1')
    } else {
      const domain = /https?:\/\/(www\.)?([^\/?&#]+)/.exec(attachment.url);
      if (['gfycat', 'tenor'].includes(attachment.provider)
        || ['gfycat.com', 'tenor.com'].includes(domain[2])) {
        showPlay = false
        classes.push(css['comment__attachment--only'])
      }
    }
  }

  if (knownProviders.includes(attachment.provider)) {
    additionalProps['data-lightbox-children'] = true
    additionalProps['data-lightbox-type'] = 'video'
    additionalProps['data-lightbox-provider'] = attachment.provider
  }

  const onError = () => {
    classes.push(css['comment__attachment__video--not-loaded'])
  }
</script>

{#if onlyAttachment && attachment.provider === 'youtube'}
    <div class={css['comment__attachment__video__player']}>
        <lite-youtube videoId={videoId} data-plugins="lite-youtube-embed" params={params} class={css['comment__attachment__video__player']}></lite-youtube>
        <slot name="delete"></slot>
    </div>
{:else}
    <a
        class={classes.join(' ')}
        href={attachment.url}
        target="_blank"
        rel="nofollow ugc"
        {...additionalProps}
    >
        <img alt=""
             src={attachment.preview_url}
             on:error={onError}
             loading="lazy"
        />
        {#if showPlay}
            <svg
                class={css['comment__attachment__video__play']}
                viewBox='0 0 40 40'
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="m25 20-7.5-5v10l7.5-5Z" stroke="white" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
            </svg>
        {/if}
        <slot name="delete"></slot>
    </a>
{/if}
